import useSWR, { SWRConfiguration } from "swr";
import { AxiosInstance } from "axios";

export type CRUDType = "create" | "update" | "delete";

// Define a generic SWR fetcher hook
export function useSWRFetcher(
  url: string | null,
  axiosInstance: AxiosInstance,
  options?: SWRConfiguration
) {
  const fetcher = (url: string) =>
    axiosInstance.get(url).then((res) => res.data);

  const { data, error, isLoading, isValidating, mutate } = useSWR(
    url,
    url ? fetcher : null,
    options
  );

  return {
    data,
    isLoading,
    isValidating,
    error,
    mutate,
  };
}
